import type { ReactNode } from 'react';
import { useClientApprovalEnforcementLive } from '../../../lib/clientApprovalEnforcement';

/**
 * #3187 APPROVE.4 — the route guard for every new Client Portal approvals URL.
 * Until CLIENT_APPROVAL_ENFORCEMENT_LIVE is true (3b), none of them is
 * reachable: when the answer is false or failed, this renders nothing, which
 * is what main shows for an unmatched URL (App.tsx RootRouteError: a 404
 * renders null, no catch-all route). The children (and so ActionRoute's probe
 * and every page fetch) never mount until it is true.
 *
 * While the answer is pending (at most ENFORCEMENT_TIMEOUT_MS) it shows a
 * neutral loading line that names nothing, rather than a blank page (R1 P3-3,
 * ruling 6587483695). A timeout or error still reads as false (G3 unchanged).
 */
export default function ClientApprovalsLiveRoute({ children }: { children: ReactNode }) {
  const live = useClientApprovalEnforcementLive();
  if (live === undefined) {
    return (
      <div data-testid="client-approvals-checking" role="status" style={{ padding: 40, textAlign: 'center', color: 'var(--text-secondary, #6b7280)' }}>
        Loading...
      </div>
    );
  }
  if (live !== true) return null;
  return <>{children}</>;
}
